import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  backdrop: {
    position: 'fixed',
    inset: 0,
    zIndex: 199
  },
  popover: {
    position: 'absolute',
    top: 'calc(100% + 6px)',
    right: 0,
    minWidth: '240px',
    backgroundColor: 'white',
    border: '1px solid var(--color-neutral-300)',
    borderRadius: 'var(--border-radius-sm)',
    boxShadow: 'var(--shadow-md)',
    zIndex: 200,
    padding: '14px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  fieldRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px'
  },
  subLabel: {
    fontSize: '10px',
    fontWeight: 600,
    color: 'var(--color-neutral-400)'
  },
  label: {
    fontSize: '12px',
    fontWeight: 500,
    color: 'var(--color-neutral-700)'
  },
  select: {
    width: '100%',
    padding: '4px 8px',
    border: '1px solid var(--color-neutral-300)',
    borderRadius: 'var(--border-radius-sm)',
    fontSize: '12px',
    outline: 'none',
    backgroundColor: 'white',
    cursor: 'pointer',
    '&:focus': {
      borderColor: 'var(--color-primary-400)',
      boxShadow: '0 0 0 2px var(--color-primary-100)'
    }
  },
  numberInput: {
    width: '80px',
    padding: '4px 8px',
    border: '1px solid var(--color-neutral-300)',
    borderRadius: 'var(--border-radius-sm)',
    fontSize: '12px',
    textAlign: 'right',
    fontFamily: 'var(--font-mono, monospace)',
    outline: 'none',
    '&:focus': {
      borderColor: 'var(--color-primary-400)',
      boxShadow: '0 0 0 2px var(--color-primary-100)'
    }
  }
}))

function SummitConfigPopover ({
  skillTag,
  onSkillTagChange,
  models,
  modelOverride,
  onModelOverrideChange,
  temperatureOverride,
  onTemperatureOverrideChange,
  maxTokensOverride,
  onMaxTokensOverrideChange,
  onClose
}) {
  const classes = useStyles()

  return (
    <>
      <div className={classes.backdrop} onClick={onClose} />
      <div className={classes.popover}>
        <div className={classes.field}>
          <span className={classes.subLabel}>Skills Version</span>
          <select
            className={classes.select}
            value={skillTag}
            onChange={(e) => onSkillTagChange(e.target.value)}
          >
            <option value='live'>live</option>
            <option value='next'>next</option>
          </select>
        </div>

        <div className={classes.field}>
          <span className={classes.subLabel}>Model Override</span>
          <select
            className={classes.select}
            value={modelOverride || ''}
            onChange={(e) => onModelOverrideChange(e.target.value || null)}
          >
            <option value=''>Default</option>
            {(models || []).filter(m => m.enabled !== false).map(m => (
              <option key={m.modelId} value={m.modelId}>{m.displayName || m.modelId}</option>
            ))}
          </select>
        </div>

        <div className={classes.fieldRow}>
          <span className={classes.label}>Temperature</span>
          <input
            className={classes.numberInput}
            type='number'
            min={0}
            max={1}
            step={0.1}
            placeholder='—'
            value={temperatureOverride ?? ''}
            onChange={(e) => {
              const raw = e.target.value
              const val = raw === '' ? null : parseFloat(raw)
              onTemperatureOverrideChange((val !== null && !isNaN(val) && val >= 0 && val <= 1) ? val : null)
            }}
          />
        </div>

        <div className={classes.fieldRow}>
          <span className={classes.label}>Max tokens</span>
          <input
            className={classes.numberInput}
            type='number'
            min={256}
            max={64000}
            step={256}
            placeholder='—'
            value={maxTokensOverride ?? ''}
            onChange={(e) => {
              const raw = e.target.value
              const val = raw === '' ? null : parseInt(raw, 10)
              onMaxTokensOverrideChange((val && val >= 256 && val <= 64000) ? val : null)
            }}
          />
        </div>
      </div>
    </>
  )
}

SummitConfigPopover.propTypes = {
  skillTag: PropTypes.string.isRequired,
  onSkillTagChange: PropTypes.func.isRequired,
  models: PropTypes.array,
  modelOverride: PropTypes.string,
  onModelOverrideChange: PropTypes.func.isRequired,
  temperatureOverride: PropTypes.number,
  onTemperatureOverrideChange: PropTypes.func.isRequired,
  maxTokensOverride: PropTypes.number,
  onMaxTokensOverrideChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}

export default SummitConfigPopover
